import * as React from 'react'
import { ICompany, IPayment } from '@getgreenline/homi-shared'
import { observer } from 'mobx-react'
import { LoyaltyModels } from '@getgreenline/loyalties'
import { ReceiptUtils } from '@getgreenline/receipts'

interface Props {
  company: ICompany
  payment: IPayment
  loyaltyData?: LoyaltyModels.ILoyaltyData
}

@observer
export class Receipt extends React.Component<Props, {}> {
  render() {
    const { company, payment, loyaltyData } = this.props

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: ReceiptUtils.generateReceiptHTMLV1({ company, payment, loyaltyData }),
        }}
      />
    )
  }
}
